<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH-1"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-SC">ACKNOWLEDGMENTS</span></span></p>
<p class="FMTNI">Heather Fagan,</p>
<p class="FMTNI">Dan Hollifield and Lindsey Burt-Hollifield.</p>
<p class="FMTNI">High five!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?bdd0e1f2